<template>
    <div>
        <div class="vx-row mb-6" v-if="this.reportMonth">
            <div class="vx-col w-full">
                <vx-card>
                    <vue-apex-charts type=bar height=500 :options="dailyChartOptions" :series="dailyChartData" />
                </vx-card>
            </div>

        </div>
        <div class="vx-row" v-if="this.reportMonth">
            <div class="vx-col w-full xl:w-1/6 lg:w-1/4 md:w-1/3">
                <vx-card :title="$t('Settings')" class="mb-3">
                    <p class="mt-6">{{$t("StartTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportStartTime"></flat-pickr>
                    <p class="mt-6">{{$t("EndTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportEndTime"></flat-pickr>
                    <vs-button class="mt-6" color="success" icon-pack="feather" icon="icon-edit" type="border" @click="updateReport">{{$t("Reload")}}</vs-button>
                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-1/3 ls:w-1/2 md:w-1/2 mb-3">
                <vx-card :title="$t('Times')" collapse-action>

                    <!-- CHART -->
                    <div slot="no-body">
                        <vue-apex-charts type="radialBar" height="420" :options="timesChartOptions" :series="typesPercentageSeries" />
                    </div>

                    <ul>
                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg" style="border-color: rgb(15,103,240)"></span>
                                    <span class="font-semibold">{{$t('Work')}}</span>
                            </span>
                            <span>{{report.total_work_time}}</span>
                        </li>

                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg border-warning"></span>
                                    <span class="font-semibold">{{$t('Transport')}}</span>
                            </span>
                            <span>{{report.total_transport_time}}</span>
                        </li>

                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg" style="border-color: #9b59b6"></span>
                                    <span class="font-semibold">{{$t('Meetings')}}</span>
                            </span>
                            <span>{{report.total_meetings_time}}</span>
                        </li>

                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg border-danger"></span>
                                    <span class="font-semibold">{{$t('Absence')}}</span>
                            </span>
                            <span>{{report.total_vacation_time + report.total_sick_leave_time + report.total_parental_leave_time}}</span>
                        </li>

                        <li class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg border-success"></span>
                                    <span class="font-semibold">{{$t('TimeEdits')}}</span>
                            </span>
                            <span>{{report.time_edits}}</span>
                        </li>
                    </ul>
                </vx-card>
            </div>
        </div>
        <div class="vx-row" v-if="this.report">
            <div v-if="timeList.length > 0" class="vx-col w-full mb-3">
                <vx-card :title="$t('Times')" collapse-action>
                    <vs-table ref="timesTable" :data="timeList" :max-items="itemsPerPageTimes" search pagination>

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                    <span class="mr-2">{{ itemsPerPageTimes }}</span>
                                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                                </div>

                                <vs-dropdown-menu>

                                    <vs-dropdown-item @click="itemsPerPageTimes=10">
                                        <span>10</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTimes=20">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTimes=50">
                                        <span>50</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTimes=100">
                                        <span>100</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>

                            <vs-button class="mr-6" style="float: left" color="success" icon-pack="feather" icon="icon-eye" type="border" id="userOverviewExcelButton" @click="generateOverviewExcel">{{$t("Excel")}}</vs-button>

                        </div>

                        <template slot="thead">
                            <vs-th sort-key="client_company">{{$t("Client")}}</vs-th>
                            <vs-th sort-key="task_name">{{$t("Title")}}</vs-th>
                            <vs-th sort-key="work_type">{{$t("WorkType")}}</vs-th>
                            <vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
                            <vs-th sort-key="total_time">{{$t("TotalTime")}}</vs-th>
                            <vs-th sort-key="non_invoiced_time">{{$t("NonInvoicedTime")}}</vs-th>
                            <vs-th sort-key="company_task_id">{{$t("ID")}}</vs-th>
                            <vs-th></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].client_company">
                                    {{data[indextr].client_company}}
                                </vs-td>
                                <vs-td :data="data[indextr].task_name">
                                    {{data[indextr].task_name}}
                                </vs-td>
                                <vs-td :data="data[indextr].work_type">
                                    {{data[indextr].work_type}}
                                </vs-td>

                                <vs-td :data="data[indextr].sub_times[0].start_time">
                                    {{moment(data[indextr].sub_times[data[indextr].sub_times.length-1].end_time).format('DD/MM/YYYY HH:mm')}}
                                </vs-td>

                                <vs-td :data="data[indextr].total_time">
                                    {{data[indextr].total_time}}
                                </vs-td>

                                <vs-td v-if="data[indextr].non_invoiced_part" :data="data[indextr].non_invoiced_time">
                                    <vs-chip class="mr-3" :color="(data[indextr].non_invoiced_time >= data[indextr].total_time) ? 'danger' : 'warning'">
                                        {{data[indextr].non_invoiced_time}}
                                    </vs-chip>

                                </vs-td>

                                <vs-td v-else :data="0">
                                    0
                                </vs-td>

                                <vs-td :data="data[indextr].company_task_id">
                                    {{data[indextr].company_task_id}}
                                </vs-td>

                                <vs-td>
                                    <vs-button size="small" color="success" icon-pack="feather" icon="icon-eye" type="border" class="mr-3" @click="$router.push({ name: 'task', params: { id: data[indextr].task_id } })"></vs-button>
                                </vs-td>

                                <template slot="expand" >
                                    <vs-row vs-w="12">
                                        <vs-col vs-w="6" vs-sm="12" class="mt-6">
                                            <div class="mb-base" id="page-user-view">

                                                <table>
                                                    <tr>
                                                        <td class="font-semibold">{{$t("Notes")}}</td>
                                                    </tr>
                                                </table>
                                                <p style="white-space: pre-wrap">{{data[indextr].notes}}</p>

                                            </div>
                                        </vs-col>
                                        <vs-col vs-w="6" vs-sm="12" class="mt-6">
                                            <vs-table :data="data[indextr].sub_times">

                                                <template slot="thead">
                                                    <vs-th sort-key="start_time">{{$t("StartTime")}}</vs-th>
                                                    <vs-th sort-key="end_time">{{$t("EndTime")}}</vs-th>
                                                </template>

                                                <template slot-scope="{data}">
                                                    <vs-tr :data="tr1" :key="index1" v-for="(tr1, index1) in data">

                                                        <vs-td :data="data[index1].start_time">
                                                            {{ moment(data[index1].start_time).format('DD/MM/YYYY HH:mm') }}
                                                        </vs-td>

                                                        <vs-td :data="data[index1].end_time">
                                                            {{ moment(data[index1].end_time).format('DD/MM/YYYY HH:mm') }}
                                                        </vs-td>
                                                    </vs-tr>
                                                </template>
                                            </vs-table>
                                        </vs-col>
                                    </vs-row>
                                </template>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>

        <div class="vx-row" v-if="this.report">
            <div v-if="transportList.length > 0" class="vx-col w-full mb-3">
                <vx-card :title="$t('Transport')" collapse-action>
                    <vs-table ref="transportTable" :data="transportList" :max-items="itemsPerPageTransport" search pagination>

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                    <span class="mr-2">{{ itemsPerPageTransport }}</span>
                                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                                </div>

                                <vs-dropdown-menu>

                                    <vs-dropdown-item @click="itemsPerPageTransport=10">
                                        <span>10</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTransport=20">
                                        <span>20</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTransport=50">
                                        <span>50</span>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="itemsPerPageTransport=100">
                                        <span>100</span>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>

                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                            <vs-th>{{$t("StartPoint")}}</vs-th>
                            <vs-th>{{$t("Destination")}}</vs-th>
                            <vs-th>{{$t("Vehicle")}}</vs-th>
                            <vs-th>{{$t("Notes")}}</vs-th>
                            <vs-th>{{$t("TransportType")}}</vs-th>
                            <vs-th>{{$t("TotalTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start_time">
                                    {{moment(data[indextr].start_time).format('DD/MM/YYYY HH:mm')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end_time">
                                    {{moment(data[indextr].end_time).format('DD/MM/YYYY HH:mm')}}
                                </vs-td>

                                <vs-td :data="data[indextr].start_point">
                                    {{data[indextr].start_point}}
                                </vs-td>

                                <vs-td :data="data[indextr].end_point">
                                    {{data[indextr].end_point}}
                                </vs-td>

                                <vs-td :data="data[indextr].vehicle">
                                    {{data[indextr].vehicle}}
                                </vs-td>

                                <vs-td :data="data[indextr].notes">
                                    {{data[indextr].notes}}
                                </vs-td>

                                <vs-td :data="data[indextr].transport_type">
                                    {{data[indextr].transport_type}}
                                </vs-td>

                                <vs-td :data="data[indextr].total_time">
                                    {{data[indextr].total_time}}
                                </vs-td>

                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>
        <div class="vx-row" v-if="this.report">
            <div v-if="report.vacations.length > 0" class="vx-col w-full mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2">
                <vx-card :title='$t("VacationDays")' collapse-action>
                    <vs-table :data="report.vacations">
                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start">
                                    {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end">
                                    {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>

            <div v-if="report.absences.length > 0" class="vx-col w-full mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2">
                <vx-card :title='$t("PlannedAbsence")' collapse-action>
                    <vs-table :data="report.absences">
                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start">
                                    {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end">
                                    {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>

            <div v-if="report.sick_leaves.length > 0" class="vx-col w-full mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2">
                <vx-card :title='$t("SickLeaves")' collapse-action>
                    <vs-table :data="report.sick_leaves">
                        <template slot="thead">
                            <vs-th>{{$t("StartTime")}}</vs-th>
                            <vs-th>{{$t("EndTime")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].start">
                                    {{moment(data[indextr].start).format('DD/MM/YYYY')}}
                                </vs-td>
                                <vs-td :data="data[indextr].end">
                                    {{moment(data[indextr].end).format('DD/MM/YYYY')}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>
        <vx-card class="w-full mt-6 mb-6">
            <vue-apex-charts type="bar" height="500" :options="this.yearlyChartOptions" :series="yearlyChartData"/>
        </vx-card>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            flatPickr,
            VueApexCharts
        },
        props: {
            userId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {

                itemsPerPageTimes: 100,
                isMounted: false,
                currentPageTimes: 1,

                itemsPerPageTransport: 10,
                currentPageTransport: 1,

                report: null,
                reportStartTime: null,
                reportEndTime: null,

                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },


                timesChartOptions: {
                    labels: [this.$t('Work'), this.$t('Transport'), this.$t('Absence'), this.$t('Meetings')],
                    plotOptions: {
                        radialBar: {
                            size: 165,
                            offsetY: -5,
                            hollow: {
                                size: '25%'
                            },
                            track: {
                                background: "#ebebeb",
                                strokeWidth: '100%',
                                margin: 15,
                            },
                            dataLabels: {
                                show: true,
                                name: {
                                    fontSize: '18px',
                                },
                                value: {
                                    fontSize: '16px',
                                    color: "#636a71",
                                    offsetY: 11
                                },
                                total: {
                                    show: true,
                                    label: this.$t('Total'),
                                    formatter: this.getTotal,
                                }
                            }
                        },
                    },
                    responsive: [{
                        breakpoint: 576,
                        options: {
                            plotOptions: {
                                radialBar: {
                                    size: 150,
                                    hollow: {
                                        size: '20%'
                                    },
                                    track: {
                                        background: "#ebebeb",
                                        strokeWidth: '100%',
                                        margin: 15,
                                    },
                                }
                            }
                        }
                    }],
                    colors: ['#7961F9', '#FF9F43', '#EA5455', '#9b59b6'],
                    fill: {
                        type: 'gradient',
                        gradient: {
                            // enabled: true,
                            shade: 'dark',
                            type: 'vertical',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#9c8cfc', '#FFC085', '#f29292', '#bb79d6'],
                            inverseColors: false,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100]
                        },
                    },
                    stroke: {
                        lineCap: 'round'
                    },
                    chart: {
                        height: 355,
                        dropShadow: {
                            enabled: true,
                            blur: 3,
                            left: 1,
                            top: 1,
                            opacity: 0.1
                        },
                    }
                },

                dailyChartOptions: {},
                yearlyChartOptions: {},
                reportMonth: null,
            }
        },
        methods: {
            updateReport() {
                const thisIns = this;
                this.$http.post('/api/v1/user/' + this.userId + '/report', {
                    start_time: thisIns.moment(thisIns.reportStartTime).format(),
                    end_time: thisIns.moment(thisIns.reportEndTime).add(1, 'd').subtract(1, 'ms').format(),
                }).then(function (response) {
                    thisIns.report = response.data;
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            getTotal() {
                return this.report.total_time
            },
            updateDailyChartCategories() {

                let thisIns = this;

                this.dailyChartOptions = {
                    grid: {
                        borderColor: '#ebebeb',
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        stacked: true,
                        type: 'bar',
                        events: {
                            dataPointSelection: function(event, chartContext, config) {
                                let currentTime = new Date();
                                thisIns.reportEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), config.dataPointIndex + 1);
                                thisIns.reportStartTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), config.dataPointIndex + 1);
                                thisIns.updateReport();
                            }
                        }
                    },
                    colors: ['#badc58', '#078e40', '#D2691E', '#34495e', '#3498db', '#4834d4', '#e74c3c', '#9b59b6'],
                    plotOptions: {
                        bar: {
                            columnWidth: '70%',
                        }
                    },
                    xaxis: {
                        axisTicks: {
                            show: false,
                        },
                        categories: this.reportDays,
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        tickAmount: 5,
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            }
                        }
                    },
                    tooltip: {
                        x: { show: false }
                    },
                };

            },
            updateYearlyChart() {
                this.yearlyChartOptions = {
                    colors: ['#28C76F', '#7367F0', '#EA5455'],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },

                    xaxis: {
                        categories: this.yearlyChartCategories,
                    },
                    yaxis: {
                        title: {
                            text: 'h'
                        }
                    },
                    fill: {
                        opacity: 1

                    },
                    tooltip: {
                        y: {
                            formatter: function(val) {
                                return val + "h"
                            }
                        }
                    }
                }
            },
            generateOverviewExcel(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#userOverviewExcelButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.post('/api/v1/user/' + this.userId + '/report/excel', {
                    start_time: thisIns.moment(thisIns.reportStartTime).format(),
                    end_time: thisIns.moment(thisIns.reportEndTime).add(1, 'd').subtract(1, 'ms').format(),
                })
                    .then(function (response) {
                        thisIns.$vs.loading.close("#userOverviewExcelButton > .con-vs-loading");
                        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                            window.location.href = '/api/v1/user/' + thisIns.userId + '/report/excel/' + response.data;
                        }else{
                            window.open('/api/v1/user/' + thisIns.userId + '/report/excel/' + response.data, "_blank");
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#userOverviewExcelButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
        },
        computed: {
            dailyChartData: function () {

                let data = [];
                let times = [];
                let uninvoiced = [];
                let transport = [];
                let sickLeaves = [];
                let parentalLeaves = [];
                let vacations = [];
                let businessTrips = [];
                let meetings = [];

                if(this.reportMonth && this.reportMonth.days) {
                    for (let key in this.reportMonth.days) {
                        if (this.reportMonth.days.hasOwnProperty(key)) {
                            uninvoiced.push(this.reportMonth.days[key].un_invoiced_time.toFixed(2));
                            times.push(this.reportMonth.days[key].total_work_time.toFixed(2));
                            transport.push(this.reportMonth.days[key].total_transport_time.toFixed(2));
                            vacations.push(this.reportMonth.days[key].vacation_time.toFixed(2));
                            sickLeaves.push(this.reportMonth.days[key].sick_leave_time.toFixed(2));
                            parentalLeaves.push(this.reportMonth.days[key].parental_leave_time.toFixed(2));
                            businessTrips.push(this.reportMonth.days[key].business_trip_time.toFixed(2));
                            meetings.push(this.reportMonth.days[key].total_meetings_time.toFixed(2));

                        }
                    }
                }

                data.push({name: this.$t("Work"), data: times});
                data.push({name: this.$t("NonInvoicedTime"), data: uninvoiced});
                data.push({name: this.$t("Transport"), data: transport});
                data.push({name: this.$t("SickLeaves"), data: sickLeaves});
                data.push({name: this.$t("ParentalLeaves"), data: parentalLeaves});
                data.push({name: this.$t("Vacations"), data: vacations});
                data.push({name: this.$t("BusinessTrips"), data: businessTrips});
                data.push({name: this.$t("Meetings"), data: meetings});

                return data;

            },
            yearlyChartCategories: function () {

                let categories = [];

                if(this.reportMonth && this.reportMonth.last_year_reports) {

                    if(this.reportMonth.last_year_reports.length < 12) {
                        for(let x = 0; x < 12-this.reportMonth.last_year_reports.length; x++) {
                            categories.push("");
                        }
                    }

                    for(let x = 0; x < this.reportMonth.last_year_reports.length; x++){

                        switch (this.reportMonth.last_year_reports[x].month) {
                            case 1: categories.push(this.$t("January")); break;
                            case 2: categories.push(this.$t("February")); break;
                            case 3: categories.push(this.$t("March")); break;
                            case 4: categories.push(this.$t("April")); break;
                            case 5: categories.push(this.$t("May")); break;
                            case 6: categories.push(this.$t("June")); break;
                            case 7: categories.push(this.$t("July")); break;
                            case 8: categories.push(this.$t("August")); break;
                            case 9: categories.push(this.$t("September")); break;
                            case 10: categories.push(this.$t("October")); break;
                            case 11: categories.push(this.$t("November")); break;
                            case 12: categories.push(this.$t("December")); break;
                        }
                    }
                }

                return categories;

            },
            yearlyChartData: function () {

                let workTimes = [];
                let neededTimes = [];
                let differences = [];

                if(this.reportMonth && this.reportMonth.last_year_reports) {

                    if(this.reportMonth.last_year_reports.length < 12) {
                        for(let x = 0; x < 12-this.reportMonth.last_year_reports.length; x++) {
                            workTimes.push(0);
                            neededTimes.push(0);
                            differences.push(0);
                        }
                    }

                    for(let x = 0; x < this.reportMonth.last_year_reports.length; x++){
                        workTimes.push(this.reportMonth.last_year_reports[x].time_worked);
                        neededTimes.push(this.reportMonth.last_year_reports[x].time_needed);
                        differences.push(this.reportMonth.last_year_reports[x].monthly_difference);
                    }
                }

                let data = [];
                data.push({name: this.$t("Work"), data: workTimes});
                data.push({name: this.$t("HoursNeeded"), data: neededTimes});
                data.push({name: this.$t("MonthlyDifference"), data: differences});

                return data;

            },
            reportDays: function () {

                let categories = [];

                if(this.reportMonth && this.reportMonth.days) {
                    for (let key in this.reportMonth.days) {
                        if (this.reportMonth.days.hasOwnProperty(key)) {
                            categories.push(this.moment(key).format("D"))
                        }
                    }
                }

                return categories

            },
            overviewPercentageSeries: function () {

                let data = [];

                if(this.report.needed_time) {
                    data.push(Number(this.report.done_percentage));
                }
                return data;
            },
            typesPercentageSeries: function () {

                let data = [];

                if(this.report) {
                    data.push(this.report.time_percentage);
                    data.push(this.report.transport_percentage);
                    data.push(this.report.absence_percentage);
                    data.push(this.report.meetings_percentage);

                    return data;
                }

                return [0,0,0,0];
            },
            timeList: function () {
                let list = [];
                if(this.report) {
                    for (let key in this.report.days){
                        if(this.report.days.hasOwnProperty(key)){
                            list.push(...this.report.days[key].times)
                        }
                    }
                }

                return list;
            },
            transportList: function () {
                let list = [];
                if(this.report) {
                    for (let key in this.report.days){
                        if(this.report.days.hasOwnProperty(key)){
                            list.push(...this.report.days[key].transports)
                        }
                    }
                }

                return list;
            }
        },
        mounted() {
            let currentTime = new Date();
            this.reportEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate());
            this.reportStartTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate());
            this.updateReport();
            this.isMounted = true;

            const thisIns = this;
            this.$http.get('/api/v1/user/' + this.userId + '/report')
                .then(function (response) {
                    thisIns.reportMonth = response.data;
                    thisIns.updateDailyChartCategories();
                    thisIns.updateYearlyChart();

                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
        },
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
